import { curry } from 'ramda';
import { chain, of } from 'fantasy-land';
// eslint-disable-next-line node/file-extension-in-import -- needs to disambiguate with .svelte
import Flow from './Flow.js';

export default function doFlow(generator) {
  const next = curry(async (iter, input) => {
    const { value, done } = await iter.next(input);
    if (done) {
      return Flow[of](value);
    }
    return value[chain](next(iter));
  });
  return Flow[of](undefined)[chain](() => next(generator(), undefined));
}
